import { createFileRoute } from '@tanstack/react-router';

import { useSEO, useBreadcrumbSchema, PageSEO } from '../lib/seo';
import { LegalDocPage } from '../components/legal/LegalDocPage';
// Body extracted verbatim from sites/www/public/legal/dpa/index.html (see privacy.tsx note).
import dpaBody from '../content/legal/dpa.body.html?raw';

export const Route = createFileRoute('/legal/dpa')({
  component: DpaPage,
});

function DpaPage() {
  useSEO(PageSEO.dpa);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust', url: '/trust' },
    { name: 'Data Processing Agreement', url: '/legal/dpa' },
  ]);

  return (
    <LegalDocPage
      title="Data Processing Agreement"
      breadcrumbLabel="Data Processing Agreement"
      metaLine="Processor Terms · Last updated 21 April 2026"
      subtitle="Processor Terms governing how Neumind processes personal data on behalf of Customer organisations."
    >
      <div dangerouslySetInnerHTML={{ __html: dpaBody }} />
    </LegalDocPage>
  );
}
